module.exports = __webpack_public_path__ + "img/emergency_kit_01.5ebd8696.jpg";